/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {BundleInformationTableComponent} from './bundle-information-table.component';
import {TableModule} from '../../shared/table/table.module';
import {CardModule} from '../../shared/card/card.module';
import {BundleSettlementsTableModule} from '../bundle-settlements-table/bundle-settlements-table.module';
import {CommonModule} from '@angular/common';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {BundlesPipesModule} from '../shared/pipes/bundles-pipes.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {SwitchButtonModule} from '../../shared/switch-button/switch-button.module';
import {FlyingMenuModule} from '../../shared/flying-menu/flying-menu.module';
import {InfoChartModule} from '../../shared/info-chart/info-chart.module';

@NgModule({
    imports: [
        TableModule,
        PipesModule,
        CardModule,
        BundleSettlementsTableModule,
        CommonModule,
        TooltipModule,
        BundlesPipesModule,
        SwitchButtonModule,
        FlyingMenuModule,
        InfoChartModule
    ],
    declarations: [BundleInformationTableComponent],
    exports: [BundleInformationTableComponent]
})
export class BundleInformationTableModule {
}
